var _path, _path2, _path3, _defs, _clipPath, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 35,
    width: 55,
    viewBox: "0 275 400 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M341 548.6H71.4c-16.9 0-30.8-15.9-30.8-32.8V346.9c0-16.9 13.9-30.8 30.8-30.8H341c16.9 0 30.8 13.9 30.8 30.8v168.8c0 17-13.8 32.9-30.8 32.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#646667",
    d: "M74.6 545.1c-17.6 0-32-14.3-32-32v-165c0-17.6 14.3-32 32-32h263.3c17.6 0 32 14.3 32 32v165c0 17.6-14.3 32-32 32H74.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 131.343,
    y1: 600.243,
    x2: 131.343,
    y2: 673.389,
    gradientTransform: "matrix(3.06 0 0 -3.06 -195.7 2378.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dbdbdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#e8e8e9"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Discover_svg__a)",
    d: "M337.1 542H75.4c-16.4 0-29.9-13.5-29.9-29.9v-164c0-16.5 13.5-29.9 29.9-29.9h261.7c16.4 0 29.9 13.5 29.9 29.9v164c0 16.4-13.5 29.9-29.9 29.9z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Discover_svg__b",
    d: "M367 512.3c0 16.5-13.4 29.9-29.9 29.9H75.4c-16.5 0-29.9-13.4-29.9-29.9V347.8c0-16.5 13.4-29.9 29.9-29.9h261.7c16.5 0 29.9 13.4 29.9 29.9v164.5z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_svg__c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Discover_svg__b",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Discover_svg__c)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M367 452.1s-88.2 62.3-249.8 90.1H367v-90.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_svg__d",
    cx: 127.591,
    cy: 1128.557,
    r: 7.749,
    gradientTransform: "matrix(3.06 0 0 -3.06 -176.067 3866.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#ffeee1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#fde8d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "#fcdbc0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    style: {
      stopColor: "#fbc698"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    style: {
      stopColor: "#f8a561"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f48220"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Discover_svg__d)",
    d: "M214.4 389.3c-13.3 0-24 10.4-24 23.1 0 13.6 10.3 23.7 24 23.7 13.4 0 23.9-10.3 23.9-23.5 0-13-10.5-23.3-23.9-23.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#081A23",
    d: "M78.1 390.2H65.2v45H78c6.8 0 11.7-1.6 16.1-5.2 5.1-4.3 8.2-10.7 8.2-17.3-.1-13.3-10-22.5-24.2-22.5zM88.3 424c-2.8 2.5-6.3 3.6-12 3.6H74v-29.8h2.4c5.7 0 9.1 1 12 3.6 3 2.7 4.8 6.9 4.8 11.2 0 4.4-1.8 8.7-4.9 11.4zM106.3 390.2h8.8v45h-8.8zM136.5 407.4c-5.3-2-6.8-3.2-6.8-5.7 0-2.8 2.8-5 6.5-5 2.6 0 4.8 1.1 7.1 3.6l4.6-6c-3.8-3.3-8.3-5-13.2-5-8 0-14 5.5-14 12.9 0 6.2 2.8 9.4 11.1 12.4 3.4 1.2 5.2 2 6.1 2.6 1.8 1.1 2.6 2.8 2.6 4.7 0 3.7-2.9 6.3-6.8 6.3-4.2 0-7.6-2.1-9.6-6l-5.7 5.5c4 5.9 8.9 8.6 15.6 8.6 9.1 0 15.5-6.1 15.5-14.8 0-7.2-3-10.4-13-14.1zM152.3 412.7c0 13.2 10.4 23.5 23.8 23.5 3.8 0 7-.7 11-2.6v-10.3c-3.5 3.5-6.6 4.9-10.6 4.9-8.8 0-15.1-6.4-15.1-15.5 0-8.6 6.5-15.5 14.7-15.5 4.2 0 7.4 1.5 11 5.1V392c-3.8-2-7-2.8-10.8-2.8-13.4 0-24 10.4-24 23.5zM258.2 420.4l-12-30.2h-9.6l19.1 46.1h4.7l19.5-46.1h-9.5zM283.9 435.2h24.9v-7.6h-16.1v-12.2h15.5v-7.6h-15.5v-10h16.1v-7.6h-24.9zM343.6 403.5c0-8.4-5.8-13.3-15.9-13.3h-13v45h8.8v-18.1h1.1l12.1 18.1h10.8l-14.2-19c6.6-1.3 10.3-5.8 10.3-12.7zm-17.7 7.4h-2.6v-13.6h2.7c5.5 0 8.5 2.3 8.5 6.7 0 4.5-2.9 6.9-8.6 6.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m143.9 447 11.7 12.3v-11.7h1.7v15.7L145.6 451v11.6h-1.7V447z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M143.7 447v15.9h2v-11.4c.5.5 11.7 12.3 11.7 12.3v-16.3h-2v11.4c-.5-.5-11.7-12.3-11.7-12.3v.4zm.3.4c.5.5 11.8 12.3 11.8 12.3v-11.9h1.4V463c-.5-.5-11.7-12.3-11.7-12.3v11.8h-1.4c-.1-.2-.1-14.3-.1-15.1zM165.4 447.7h7.8v1.6h-6.1v4.5h6v1.6h-6v5.9h6.1v1.6h-7.8v-15.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M173.2 447.5h-8v15.4h8.1V461h-6.1v-5.6h5.9v-1.9h-5.9v-4.2h6.1v-1.9h-.1zm-.1.3v1.2H167v4.8h6v1.2h-6v6.2h6.1v1.2h-7.5v-14.8c.3.2 7.2.2 7.5.2zM185.1 462.7h-1.7v-13.5h-3.6v-1.6h9v1.6h-3.7v13.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M188.8 447.5h-9.2v1.9h3.6v13.5h2v-13.5h3.7v-1.9h-.1zm-.2.3v1.2h-3.7v13.5h-1.4V449h-3.6v-1.2h8.7zM200 459l4.9-12.1 4.9 12.1 4-11.3h1.8l-5.8 15.8-4.9-12.1-4.9 12.1-5.8-15.8h1.8l4 11.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M204.7 446.8s-4.4 11-4.7 11.7c-.3-.7-3.9-11-3.9-11H194l6 16.4s4.6-11.5 4.9-12.2c.3.7 4.9 12.2 4.9 12.2l6-16.4h-2.2s-3.6 10.3-3.9 11c-.3-.7-4.9-12-4.9-12l-.1.3zm-4.6 12.2s4.5-11 4.7-11.7c.3.7 4.9 12.1 4.9 12.1s4-11.4 4.1-11.6h1.5c-.1.4-5.3 14.5-5.6 15.3-.3-.7-4.9-12.1-4.9-12.1s-4.6 11.4-4.9 12.1c-.3-.7-5.4-14.9-5.6-15.3h1.5c.1.2 4.1 11.6 4.1 11.6l.2-.4zM237.2 455.2c0 4.3-3.6 7.8-7.9 7.8-4.3 0-7.9-3.4-7.9-7.8 0-4.3 3.6-7.8 7.9-7.8 4.4 0 7.9 3.5 7.9 7.8zm-14 0c0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2 0-3.4-2.7-6.2-6.2-6.2s-6.2 2.8-6.2 6.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M221.4 455.2c0 4.4 3.6 7.9 8 7.9s8-3.6 8-7.9c0-4.4-3.6-8-8-8-4.4.1-8 3.6-8 8zm.3 0c0-4.2 3.5-7.6 7.7-7.6s7.7 3.4 7.7 7.6c0 4.2-3.5 7.6-7.7 7.6-4.3 0-7.7-3.4-7.7-7.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M223 455.2c0 3.5 2.8 6.4 6.3 6.4s6.3-2.9 6.3-6.4c0-3.5-2.8-6.4-6.3-6.4-3.4 0-6.3 2.9-6.3 6.4zm.4 0c0-3.3 2.7-6.1 6-6.1s6 2.7 6 6.1c0 3.3-2.7 6.1-6 6.1s-6-2.7-6-6.1zM246.2 462.7h-1.7v-15.1h2.2c2.9 0 5.5.8 5.5 4.2 0 2.3-1.4 4-3.8 4.2l4.8 6.8h-2.1l-4.5-6.6h-.4v6.5zm0-8.1h.5c1.9 0 3.8-.4 3.8-2.7 0-2.5-1.8-2.7-3.8-2.7h-.5v5.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M244.5 447.5h-.2v15.4h2v-6.6h.3c0 .1 4.4 6.5 4.4 6.5l2.2.1h.3s-4.6-6.5-4.8-6.8c2.2-.3 3.7-1.9 3.7-4.2 0-2.9-1.9-4.3-5.7-4.3l-2.2-.1zm2.2.3c3.6 0 5.4 1.3 5.4 4 0 2.2-1.4 3.8-3.6 4h-.3s4.5 6.3 4.8 6.7h-1.8c0-.1-4.4-6.5-4.4-6.5l-.5-.1h-.3v6.6h-1.4v-14.8c.3.1 2.1.1 2.1.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M246.2 449.1h-.2v5.7h.7c1.9 0 4-.3 4-2.9 0-2.7-2.1-2.9-4-2.9h-.5zm.5.3c1.9 0 3.7.2 3.7 2.6 0 2.2-1.8 2.5-3.7 2.5h-.4v-5.1h.4zM268.4 447.7h2.3l-7.1 7 7.3 8h-2.3l-6.2-6.9-.4.4v6.5h-1.7v-15.1h1.7v6.5l6.4-6.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M270.7 447.5h-2.3l-6.2 6.2v-6.2h-2v15.4h2v-6.6l.2-.2c.2.2 6.1 6.8 6.1 6.8l2.4.1h.4s-7.3-8-7.5-8.2l7.2-7.2-.3-.1zm-.4.3-6.9 6.9s6.7 7.4 7.2 7.9h-2c0-.1-6.1-6.9-6.1-6.9l-.1-.1-.5.5v6.5h-1.4v-14.8h1.4v6.7s6.5-6.6 6.6-6.7h1.8z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M337.1 317.9H75.3c-16.9 0-29.9 12.2-29.9 29.9v7.5c0-16.5 7-33.9 29.9-33.9H337c21 0 29.9 17.4 29.9 33.9v-7.5c.1-16.5-13.1-29.9-29.8-29.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    d: "M75.3 542.2H337c16.9 0 29.9-12.2 29.9-29.9v-7.5c0 16.5-7 33.9-29.9 33.9H75.3c-21 0-29.9-17.4-29.9-33.9v7.5c0 16.6 13.2 29.9 29.9 29.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D36928",
    d: "M117.1 542.2h220c16.5 0 29.4-11.7 29.9-28.8v-8.6 1.7c-.5 16-7.8 32.2-29.9 32.2H136"
  })));
};
export default SvgDiscover;